



























































































import {Component, Vue} from 'vue-property-decorator';
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceInvoice,
	ServiceInvoiceFilter,
	ServiceRecordDTO,
	ServiceRecordFilter
} from "@/components/payroll/business/services/ServiceDTO";
import {IEmployment} from "@/dto/payroll/IEmployment";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import ServiceRecordOrchestrator from "@/services/ServiceLogOrchestrator";
import TimeSheetDetails from "@/components/payroll/timesheet/TimeSheetDetails.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import {subSrtIfNeed} from "../../../../utils/StringUtils";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import AssignWorkServiceLog from "@/components/payroll/business/services/service/AssignWorkServiceLog.vue";

@Component({
	methods: {subSrtIfNeed},
	components: {AssignWorkServiceLog, ServiceInvoiceItem, ServiceLogView, TimeSheetDetails, PaginationComponent}
})
export default class EmployerServiceLogList extends Vue {

	private assignWork = false

	private records: Page<ServiceRecordDTO> = EMPTY_PAGE;

	private filter = new ServiceRecordFilter(
		{
			recipientId: this.$wss.getCurrent.id,
		}
	)

	mounted() {
		Application.startLoading()
		this.loadServiceRecords()
			.finally(() => Application.stopLoading())
	}

	private loadServiceRecords() {
		return ServiceRecordOrchestrator.getPageByFilter(this.filter).then(
			res => {this.records = res.data},
			err => processError(err, this)
		)
	}

	private loadNextPage(page: number) {
		this.filter.page = page
		Application.startLoading()
		this.loadServiceRecords()
			.finally(() => Application.stopLoading())
	}

	private close(record: ServiceRecordDTO) {
		(this.$refs[`popover_${record.id}`] as Array<Vue>)[0].$emit("close")
	}

	private disable(record: ServiceRecordDTO) {
		this.close(record)
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => {
					Application.startLoading()
					ServiceRecordOrchestrator.disableLog(record.id, record.executor.id).then(
						() => {
							return Promise.all(
								[
									this.loadServiceRecords(),
								]
							)
						},
						err => processError(err, this)
					).finally(Application.stopLoading)
				},
				targetName: `"${record.title}"`,
				operationName: 'disable'
			}
		)
	}

	private update() {
		Application.startLoading()
		return Promise.all(
			[
				this.loadServiceRecords(),
			]
		).finally(Application.stopLoading)
	}
}
